import { Directive, ElementRef } from '@angular/core';
import { UserInputService } from '../services/userInput.service';

@Directive({
  selector: '[nfp-remove-whitespace]',
  host: {
    '(paste)': 'handlePaste($event)',
    '(change)': 'handleChange($event)'
  }
})
export class RemoveWhiteSpaceDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    private userInputService: UserInputService
  ) {}

  handlePaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const cleaned = this.userInputService.removeTabsAndLineBreaks(pastedText);
    this.updateInputValue(cleaned);
  }

  handleChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const cleaned = this.userInputService.removeTabsAndLineBreaks(input.value);
    if (input.value !== cleaned) {
      this.updateInputValue(cleaned);
    }
  }
  
  private updateInputValue(value: string): void {
    const input = this.el.nativeElement;
    input.value = value;
    input.dispatchEvent(new Event('input'));
  }
}
